module.exports = __webpack_public_path__ + "img/begin-decorator-circles.e3765829.svg";